import axios from "axios";
export { carCompanyActions };
axios.defaults.withCredentials = true;
function carCompanyActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getCarCompanyQueryParams,
    exportData,
    acrissVehicleType,
  };
  async function getCarCompanyQueryParams(
    pageNumber: number,
    pageSize: number,
    tenant: string,
    description?: string,
    code?: string
  ) {
    return axios.get(`${baseUrl}/masterdatavehicle/carcompany`, {
      params: {
        pageNumber: pageNumber,
        pageSize: pageSize,
        tenant: tenant,
        description: description,
        code: code,
      },
    });
  }

  async function exportData(tenant: string, description: string, code: string) {
    const params = { tenant: tenant, description: description, code: code };
    return axios.get(`${baseUrl}/masterdatavehicle/carcompany/excel`, {
      params,
      responseType: "arraybuffer",
      headers: { "Access-Control-Allow-Origin": true },
    });
  }

  async function acrissVehicleType() {
    return axios
      .get("masterdatavehicle/acriss/vehicletype/all")
      .then((response) => response.data);
  }
}
